module.exports = __webpack_public_path__ + "static/media/main-goto-play.f4bd5ec1.ogg";